export default () =>
  import(/* webpackChunkName: 'coffee/activities/luckincard/purchase-records' */ './PurchaseRecords');
